import {
  FilterCategoryEnum,
  FilterOption,
  AdminReportExpenseFilterInput,
} from "@common/utils/graphql";

// TODO: all of this is garbage
const convertCamelCaseToTitle = (camelCaseString: string) => {
  return camelCaseString
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};

export const filtersToFilterOptions = (
  filters: AdminReportExpenseFilterInput,
): FilterOption[] => {
  const filterOptions: FilterOption[] = [];

  // TODO: if we choose to keep this pattern, fill out the rest
  if (filters.policyStatus?.length) {
    filters.policyStatus.forEach((policyStatus) => {
      filterOptions.push({
        category: FilterCategoryEnum.PolicyStatus,
        displayTitle: convertCamelCaseToTitle(policyStatus),
        displaySubtitle: "222",
        id: policyStatus,
      });
    });
  }

  if (filters.expenseStatus?.length) {
    filters.expenseStatus.forEach((expenseStatus) => {
      filterOptions.push({
        category: FilterCategoryEnum.ExpenseStatus,
        displayTitle: convertCamelCaseToTitle(expenseStatus),
        displaySubtitle: "222",
        id: expenseStatus,
      });
    });
  }

  return filterOptions;
};
